<template>
    <div>
        <BackgroundOverlay @overlayClickListener='overlayClick' :show_overlay='show_popout'/>

        <div :id='id' :ref="id" class='side-popout-container closed'>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import BackgroundOverlay from '@/ecom/components/overlays/BackgroundOverlay.vue'

export default {
    props: ['id', 'open_watcher', 'close_watcher'],
    components: {BackgroundOverlay},
    data(){
        return{
            show_popout: false
        }
    },
    methods:{
        overlayClick(){
            this.toggleFiltersPopout();
            this.show_popout = false;
        },
        toggleFiltersPopout(){
            const container = this.$refs[this.id];
            container.classList.toggle('open');
            container.classList.toggle('closed');
        },
    },
    watch:{
        'open_watcher': function(){
            this.show_popout = true;
            this.toggleFiltersPopout();
        },
        'close_watcher': function(){
            this.show_popout = false;
            this.toggleFiltersPopout();
        }
    }
}
</script>

<style lang="scss" scoped>
.side-popout-container{
    position: fixed;
    background-color: white;
    z-index: 101;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    // padding: 20px;
    width: 475px;
    overflow-y: auto;
    // height: 100dvh;
    height: 100dvh;
    padding-bottom: 200px;
    overflow-y:auto; 
    overflow-x:hidden; 
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only

    @media(max-width: 768px){
        width: 100%;
    }
}

.side-popout-container::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.side-popout-container::-webkit-scrollbar-track{ //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.side-popout-container::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.side-popout-container.open{
	transform: translateX(-0%);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.side-popout-container.closed{
	transform: translateX(100%);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

</style>